X-Content-Type-Options: nosniff
<template>
  <div class="list_boxtwo">
    <!-- 内部安全区域 -->
    <div class="list_boxtwo_sec">
      <!-- 文案 -->
      <div class="list_boxtwo_sec_left">
        <div class="list_boxtwo_sec_left_tp">
          集团<span>简介</span>
        </div>

        <div class="list_boxtwo_sec_left_js">
          集团始于1951年，砥砺至今，已开辟 生殖、医疗、康养三大支柱产业，是全国优秀的民营医疗集团之一。
        </div>
        <div class="list_boxtwo_sec_left_js">
          锦欣集团现有职工7500余人，集团依托70余年的临床发展实践与科研创新实践，形成了"产、教、研"三位一体的发展思路。
        </div>


        <div class="list_boxtwo_sec_left_list">
          <div class="list_boxtwo_sec_left_list_bom">
            <img class="ico" src="../assets/images/index_ico.png" alt="">
            <div class="p_box">
              <p class="p_box_titl">生殖、妇幼医疗保健</p>
              <p class="p_box_span">全国优质的辅助生殖提供商</p>
              <p class="p_box_span">四川省优秀民营妇产专科医疗集团</p>
            </div>
          </div>

          <div class="list_boxtwo_sec_left_list_bom">
            <img class="ico" src="../assets/images/index_ico2.png" alt="">
            <div class="p_box">
              <p class="p_box_titl">专科医疗机构</p>
              <p class="p_box_span">精神专科医疗机构</p>
              <p class="p_box_span">中医专科特色机构</p>
            </div>
          </div>

          <div class="list_boxtwo_sec_left_list_bom">
            <img class="ico" src="../assets/images/index_ico3.png" alt="">
            <div class="p_box">
              <p class="p_box_titl">康养</p>
              <p class="p_box_span">养老助残——领跑老年健康事业</p>
              <p class="p_box_span">全国敬老文明号</p>
              <p class="p_box_span">五星养老机构</p>
            </div>
          </div>

        </div>


      </div>

      <!-- 轮播 -->
      <div class="list_boxtwo_sec_right">
        <el-carousel height="1000px" direction="horizontal" indicator-position="none" arrow="never" ref="cardShowjT">
          <el-carousel-item class="swpier_box">
            <img class="imgs" mode="widthFix" src="../../src/assets/images/index_banner1.png" alt="">
          </el-carousel-item>
          <el-carousel-item class="swpier_box">
            <img class="imgs" mode="widthFix" src="../../src/assets/images/index_banner2.png" alt="">
          </el-carousel-item>
        </el-carousel>


        <!-- 翻页按钮 -->
        <div class="two_bottom">
          <div class="four_btn" @click="JTClick('left')">
            <img class="imgs" src="../assets/images/left_ic.png" alt="">
          </div>
          <div class="four_btn" @click="JTClick('right')">
            <img class="imgs" src="../assets/images/right_ico.png" alt="">
          </div>
        </div>
      </div>




    </div>


  </div>
</template>

<script>
  // 引用组件
  import Vue from "vue";
  import $ from "jquery";


  export default {
    name: ``,

    data() {
      return {

        timeOut: null,
        numbrt: '',

        Zylistdata: [], //专家列表
        RyList: [], //企业荣誉
        GyList: [], //公益活动
        Indeexbanner: [], //首页banner
      }
    },



    created: function() {
      // this.getIndexBanner()
      // this.getZjList()
      // this.getRy()
      // this.getGy()
    },



    methods: {




      // 公益活动
      JTClick(val) {
        console.log(val, "-----------1")
        if (val === 'right') {
          this.$refs.cardShowjT.next()
        } else {
          this.$refs.cardShowjT.prev()
        }
      },

    }
  }
</script>

<style scoped>
  .sectionTest {
    width: 100%;
    height: auto;
    background: #fff;
    position: relative;
  }

  /* 侧边指示栏 */
  .left_box {
    border: 1px solid red;
    position: fixed;
    right: 10px;
    bottom: 50%;
    z-index: 10000;
  }


  .content {
    width: 100%;
    height: 100vh;
    margin: 10px 0;
  }

  .contentBlock_box {
    position: relative;
  }



  /* index */
  .login {
    width: 100%;
    height: auto;
  }


  /* 第二页*/
  .list_boxtwo {
    width: 100%;
    height: auto;
    background-color: #fff;
    margin-bottom: 3%;
  }

  .list_boxtwo_sec {
    width: 80%;
    height: auto;
    margin: 0 auto;
    padding-top: 5%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .list_boxtwo_sec_left {
    width: 38%;
  }

  .list_boxtwo_sec_left_tp {
    width: 100%;
    font-size: 36px;
    font-weight: normal;
    color: #BF292C;
    padding-bottom: 16px;
  }

  .list_boxtwo_sec_left_tp span {
    font-size: 36px;
    color: #000;
  }

  .list_boxtwo_sec_left_js {
    box-sizing: border-box;
    margin-top: 0px;
    margin-bottom: 0px;
    padding: 0px;
    font-family: Arial, "Microsoft YaHei";
    line-height: 31px;
    font-size: 14px;
    white-space: normal;
    background-color: rgb(255, 255, 255);
  }

  .list_boxtwo_sec_left_list {
    width: 100%;
    height: auto;
    margin-top: 18%;
  }

  .list_boxtwo_sec_left_list_bom {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 10%;
  }

  .ico {
    width: 86px;
    height: 86px;
    border-radius: 50%;
    margin-right: 20px;
  }

  .p_box {
    width: 80%;
    height: auto;
  }

  .p_box_titl {
    font-size: 20px;
    color: #061D38;
    font-weight: bold;
  }

  .p_box_span {
    box-sizing: border-box;
    margin-top: 0px;
    margin-bottom: 0px;
    padding: 0px;
    font-family: Arial, "Microsoft YaHei";
    color: rgb(121, 121, 121);
    line-height: 28px;
    font-size: 14px;
    white-space: normal;
    background-color: rgb(255, 255, 255);
  }

  .two_bottom {
    display: flex;
    flex-direction: row;
    position: absolute;
    z-index: 10000;
    bottom: 15%;
    right: 0%;
  }


  .list_boxtwo_sec_right {
    width: 60%;
    height: 650px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
  }

  /* 第三页 */
  .three_box {
    width: 100%;
    height: 100vh;
    background-color: #fff
  }

  .three_box_header {
    width: 90%;
    height: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between
  }

  .three_box_header_left {
    width: 326px;
    height: 26px;

  }

  .three_box_header_right {
    width: 40%;
    height: auto;
  }

  .three_box_header_right_top {
    width: 100%;
    font-size: 36px;
    font-weight: normal;
    line-height: 43px;
    padding-bottom: 16px;
    text-align: right;
    margin-top: 34px;
  }

  .three_box_header_right_top span {
    font-size: 36px;
    color: #BF292C;
  }

  .three_box_header_right_p {
    font-weight: 400;
    color: #4D4D4D;
    line-height: 30px;
    text-align: right;
  }

  .three_map {
    width: 1500px;
    margin: 0 auto;
    margin-top: 2%;
    position: relative;
  }

  .three_map_one {
    position: absolute;
    top: 35%;
    left: 11%;

  }

  .three_map_two {
    position: absolute;
    top: 36%;
    right: 25.5%;
  }

  .three_map_three {
    position: absolute;
    top: 37.5%;
    right: 22.5%;

  }

  .three_map_four {
    position: absolute;
    top: 41.5%;
    right: 25.8%;

  }

  .three_map_five {
    position: absolute;
    top: 48%;
    right: 28%;

  }

  .three_map_six {
    position: absolute;
    top: 44.5%;
    right: 21.1%;
    ;
  }

  .three_map_seven {
    position: absolute;
    top: 48.5%;
    right: 22%;
  }

  .three_map_night {
    position: absolute;
    top: 55%;
    right: 26%;

  }

  .map_ico {
    width: 40px;
    height: 40px;
    margin: 0 auto;
  }


  .map_t_one {
    width: 140px;
    font-size: 16px;
    background: #BF292C;
    color: #FFF;
    padding: 3px 12px;
    border-radius: 20px;
    position: absolute;
    text-align: center;
    left: -54px;
    top: 43px;
    cursor: pointer
  }

  .map_t_two {
    width: 39px;
    font-size: 16px;
    background: #BF292C;
    color: #FFF;
    padding: 3px 12px;
    border-radius: 20px;
    position: absolute;
    text-align: center;
    left: -21px;
    top: -25px;
    cursor: pointer
  }

  .map_t_three {
    width: 39px;
    font-size: 16px;
    background: #BF292C;
    color: #FFF;
    padding: 3px 12px;
    border-radius: 20px;
    position: absolute;
    text-align: center;
    left: 23px;
    top: -2px;
    cursor: pointer
  }

  .map_t_four {
    width: 28px;
    font-size: 13px;
    background: #BF292C;
    color: #FFF;
    padding: 3px 12px;
    border-radius: 20px;
    position: absolute;
    text-align: center;
    left: 17px;
    top: -2px;
    cursor: pointer
  }

  .map_t_five {
    width: 39px;
    font-size: 16px;
    background: #BF292C;
    color: #FFF;
    padding: 3px 12px;
    border-radius: 20px;
    position: absolute;
    text-align: center;
    left: -68px;
    top: 5px;
    cursor: pointer
  }


  .map_t_six {
    width: 39px;
    font-size: 16px;
    background: #BF292C;
    color: #FFF;
    padding: 3px 12px;
    border-radius: 20px;
    position: absolute;
    text-align: center;
    left: 29px;
    top: 0px;
    cursor: pointer
  }


  .map_t_seven {
    width: 39px;
    font-size: 16px;
    background: #BF292C;
    color: #FFF;
    padding: 3px 12px;
    border-radius: 20px;
    position: absolute;
    text-align: center;
    left: 29px;
    top: 0px;
    cursor: pointer
  }

  .map_t_night {
    width: 140px;
    font-size: 16px;
    background: #BF292C;
    color: #FFF;
    padding: 3px 12px;
    border-radius: 20px;
    position: absolute;
    text-align: center;
    left: -60px;
    top: 31px;
    cursor: pointer
  }


  .map_t_sec {
    display: none;
    width: 380px;
    padding: 20px 30px;
    background: #FFF;
    border-radius: 22px;
    border: 2px solid #BF292C;
    margin-top: 30px;
    position: absolute;
    z-index: 11111111;
    position: absolute;
    top: 47px;
    left: -60px;
  }

  .map_t_sec_titl {
    font-size: 20px;
    color: #061D38;
    margin-bottom: 6px;
    font-weight: bold;
  }

  .map_t_sec_text {}

  .map_t_sec_text_p {
    list-style-type: disc;
    font-weight: 400;
    color: #4D4D4D;
    line-height: 30px;
  }


  .three_map_one:hover .map_t_sec {
    display: block;
  }

  .map_t_sec_cd {
    display: none;
    width: 380px;
    padding: 20px 30px;
    background: #FFF;
    border-radius: 22px;
    border: 2px solid #BF292C;
    margin-top: 30px;
    position: absolute;
    z-index: 11111111;
    position: absolute;
    top: 32px;
    left: -17px;
  }


  .three_map_two:hover .map_t_sec_cd {
    display: block;
  }



  .map_t_sec_wh {
    display: none;
    width: 380px;
    padding: 20px 30px;
    background: #FFF;
    border-radius: 22px;
    border: 2px solid #BF292C;
    margin-top: 30px;
    position: absolute;
    z-index: 11111111;
    position: absolute;
    top: 27px;
    left: -11px;
  }

  .three_map_three:hover .map_t_sec_wh {
    display: block;
  }


  .map_t_sec_lz {
    display: none;
    width: 380px;
    padding: 20px 30px;
    background: #FFF;
    border-radius: 22px;
    border: 2px solid #BF292C;
    margin-top: 30px;
    position: absolute;
    z-index: 11111111;
    position: absolute;
    top: 15px;
    left: 5px;
  }


  .three_map_four:hover .map_t_sec_lz {
    display: block;
  }

  .map_t_sec_km {
    display: none;
    width: 380px;
    padding: 20px 30px;
    background: #FFF;
    border-radius: 22px;
    border: 2px solid #BF292C;
    margin-top: 30px;
    position: absolute;
    z-index: 11111111;
    position: absolute;
    top: 29px;
    left: -60px;
  }

  .three_map_five:hover .map_t_sec_km {
    display: block;
  }


  .map_t_sec_xg {
    display: none;
    width: 380px;
    padding: 20px 30px;
    background: #FFF;
    border-radius: 22px;
    border: 2px solid #BF292C;
    margin-top: 30px;
    position: absolute;
    z-index: 11111111;
    position: absolute;
    top: 40px;
    left: 5px;
  }


  .three_map_seven:hover .map_t_sec_xg {
    display: block;
  }

  .map_t_sec_sz {
    display: none;
    width: 380px;
    padding: 20px 30px;
    background: #FFF;
    border-radius: 22px;
    border: 2px solid #BF292C;
    margin-top: 30px;
    position: absolute;
    z-index: 11111111;
    position: absolute;
    top: 40px;
    left: -4px;
  }

  .three_map_six:hover .map_t_sec_sz {
    display: block;
  }



  .map_t_sec_lo {
    display: none;
    width: 380px;
    padding: 20px 30px;
    background: #FFF;
    border-radius: 22px;
    border: 2px solid #BF292C;
    margin-top: 30px;
    position: absolute;
    z-index: 11111111;
    position: absolute;
    top: 47px;
    left: -60px;
  }

  .three_map_night:hover .map_t_sec_lo {
    display: block;
  }














  /* 第四页 */
  .four_box {
    width: 100%;
    height: 100vh;
    background-color: #fff
  }

  .four_box_sec {
    width: 90%;
    height: auto;
    margin: 0 auto;
    margin-top: 2%;
    background-color: #fff
  }


  .four_box_titl {
    width: 100%;
    font-size: 36px;
    font-weight: normal;
    line-height: 43px;
    padding-bottom: 16px;
  }

  .four_box_titl span {
    font-size: 36px;
    color: #BF292C;
  }

  .four_box_lp {
    width: 100%;
    height: 750px;
    position: relative;
  }

  .four_box_img {
    width: 100%;
    height: 750px;
  }

  .four_bottom {
    display: flex;
    flex-direction: row;
    position: absolute;
    z-index: 10000;
    bottom: 15%;
    right: 0%;
  }

  .four_box_img_sec {
    width: 100%;
    height: 750px;
    position: relative;
  }

.imgs{
  width: 100%;
  height: auto;
}

  .imgs_tap {
    width: 100%;
    height: 56px;
    background: rgba(90, 90, 90, 0.5);
    z-index: 10000;
    position: absolute;
    bottom: 0px;
    color: #fff;
    line-height: 56px;
    text-align: left;
    padding: 0 20px;
    font-size: 21px;
  }

  /* 第五页 */
  .five_box {
    width: 100%;
    height: auto;
  }

  .five_box_sec {
    width: 90%;
    height: auto;
    margin: 0 auto;
    padding-top: 2%;
  }

  .five_box_sec_tap {
    width: 100%;
    font-size: 36px;
    font-weight: normal;
    color: #BF292C;
    padding-bottom: 16px;
  }

  .five_box_sec_tap span {
    font-size: 36px;
    color: #000;
  }

  .five_box_sec_span {
    font-weight: 400;
    color: #4D4D4D;
    line-height: 30px;
    margin-bottom: 2%;
  }

  .five_box_lb {
    width: 100%;
    height: 720rpx;
  }

  .five_box_list {
    width: 100%;
    height: auto;
    overflow: hidden;
  }

  .five_box_list_sec {
    text-align: center;
    height: 360px;
    padding: 10px 0;
    transform: all 0.5s linear;
    opacity: 0.7;
    -moz-opacity: 0.7;
    -webkit-opacity: 0.7;
    filter: alpha(opacity=70);
    transition: all 0.5s linear;
    -webkit-transition: all 0.5s linear;
    float: left;
    width: 33%;
    margin: 0 auto;
  }

  .five_box_list_sec:hover {
    opacity: 1;
    -moz-opacity: 1;
    -webkit-opacity: 1;
    filter: alpha(opacity=100);
    transform: scale(1.1);
    -webkit-transform: scale(1.1);
    -moz-transform: scale(1.1);
    transform: all 0.5s linear;
    cursor: pointer;
    background: #FFF;
    box-shadow: 0px 12px 32px 0px rgba(11, 20, 57, 0.0600), 0px 4px 12px 0px rgba(0, 0, 0, 0.0300);
  }


  .sec_header {
    width: 170px;
    height: 170px;
    border-radius: 85px;
    overflow: hidden;
    margin: 20px auto;
  }

  .sec_name {
    font-size: 20px;
    line-height: 28px;
    color: #061D38;
    font-weight: bold;
  }

  .sec_titl {
    line-height: 25px;
    font-size: 14px;
    color: #061D38;
    font-weight: bold;
  }

  .sec_p {
    width: 50%;
    display: block;
    margin: 0 auto;
    line-height: 25px;
    font-size: 14px;
  }

  /* 第六页 */
  .six_box {
    width: 100%;
    height: auto;
  }

  .six_box_sec {
    width: 90%;
    height: auto;
    margin: 0 auto;
    padding-top: 5%;
    display: flex;
    flex-direction: row;
  }

  .six_box_sec_left {
    width: 66%;
    height: auto;
  }

  .six_top {
    width: 100%;
    height: auto;
    font-size: 36px;
    font-weight: normal;
    color: #BF292C;
    margin-bottom: 20px;
    text-align: right;
  }

  .six_top span {
    font-size: 36px;
    color: #000;
  }

  .six_top_p {
    width: 100%;
    display: block;
    font-size: 14px;
    font-weight: 400;
    color: #4D4D4D;
    line-height: 30px;
    text-align: right
  }

  .six_list_box {
    width: 100%;
    height: auto;
    padding-right: 8%;
    text-align: right;
    margin-top: 75px;
    display: flex;
    align-items: center;
    justify-content: right;
    padding-bottom: 20px;
  }

  .six_list_box div {
    width: 80%;
    color: #797979;
    font-size: 18px;
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    cursor: pointer
  }

  .six_list_box div:hover {
    color: #BF292C
  }


  .six_list_box span {
    width: 10px;
    height: 10px;
    background: #999;
    display: inline-block;
    margin-left: 5px;
  }


  .six_box_sec_right {
    width: 30%;
    height: auto;
    margin-top: 90px;
  }



  /deep/.el-carousel__indicator--horizontal .el-carousel__button {
    width: 40px;
    height: 4px;
    background-color: #d8d8d8;
    opacity: 0.5;
    border-radius: 20px;
  }

  /deep/.el-carousel__indicator--horizontal.is-active .el-carousel__button {
    width: 40px;
    height: 4px;
    background: #BF292C;
    opacity: 1;
    border-radius: 20px;
  }

  .four_btn {
    width: 123px;
    height: 62px;
  }
</style>



// WEBPACK FOOTER //
// src/components/indexTwo.vue